import React, { useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";
import Typography from '@mui/material/Typography';
import { Link } from "react-router-dom";


function limparHTML(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

export default function UserCard(params) {
  const user = params.user;
  const nome = params.name;
  const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;

  const url = useMemo(() => `${baseUrl}/content/associado/avatar/${nome}`, [baseUrl, nome]);
  const requestHeaders = useMemo(() => {
    const headers = new Headers();
    headers.append("X-Frontend-Client", "react-app");
    return headers;
  }, []);
  const [userAvatar, setUserAvatar] = useState([]);
  const [isLoading, setLoading] = useState(false);


  useEffect(() => {
    const fetchData = () => {
      setLoading(true);
      fetch(url, {
        method: "GET",
        headers: requestHeaders,
      })
        .then((response) => response.blob())
        .then((result) => {
          const imageObjectURL = URL.createObjectURL(result);
          setUserAvatar(imageObjectURL);
        })
        .catch((error) => console.error("Erro ao carregar avatar:", error))
        .finally(() => setLoading(false));
    };
  
    fetchData();
  }, [url, requestHeaders]);

  if (isLoading) {
    return <CircularProgress className="loading" />;
  }
  return (
    <Box className={params.location + " associado_card"}>
      <div  className="cards_item user" key={user.id} >
        <div className="user_avatar"
          alt={user.primeiro_nome}
          style={{
            alignItems: "flex-start",
            backgroundImage: "url(" + userAvatar + ")",
            backgroundPosition: 'center',
            backgroundSize: '120px 120px',
            backgroundColor: 'rgba(250, 250, 250, 0.7)',
          backgroundRepeat: 'no-repeat'}} >
          <ul className="social_equipe">
            {user.lattes &&
            <li className="lattes_equipe" >
              <a href={user.lattes} target="_blank" rel="noopener noreferrer" title="Currículo Lattes">
                <img className="social-icon-equipe lazy loaded" src="/media/lattes.webp" width="20" height="20" data-was-processed="true" alt="Currículo Lattes"/>
              </a>
            </li>
            }
            {user.instagram &&
            <li className="instagram_equipe" >
              <a href={user.instagram} target="_blank" rel="noopener noreferrer" title="Instagram">
                <img className="social-icon-equipe lazy loaded" src="/media/instagram1.webp" width="20" height="20" data-was-processed="true" alt="Instagram"/>
              </a>
            </li>
            }
            {user.linkedin &&
            <li className="linkedin_equipe" >
              <a href={user.linkedin} target="_blank" rel="noopener noreferrer" title="LinkedIn">
                <img className="social-icon-equipe lazy loaded" src="/media/linkedin1.webp" width="20" height="20" data-was-processed="true" alt="LinkedIn"/>
              </a>
              </li>
            }
          </ul>
        </div>
        <div className="user_data">
        <Link to={user.email ? `/membro/${user.email.replaceAll("@modular.org.br", "")}` : "#"} >          
          <Typography className="user_name">
            {params.location ==="equipe" ? user.primeiro_nome : `${user.primeiro_nome} ${user.sobrenome}` }
          </Typography>
        </Link>
          <Typography className="user_profissao"
            variant="body2"
          >
            {user.formacao ? user.formacao : ""}
          </Typography>
          <Typography className="user_funcao"
            variant="body2"
          >
            {user.funcao}
          </Typography>
        {params.location === "associado" ?
        <a href={`mailto://${user.email}`}  target="_blank" rel="noopener noreferrer" title="Enviar e-mail">
          <Typography className="user_mail"
            variant="body2">
            {user.email}
          </Typography>
        </a>
        :
        <></>
        }
        </div>
      </div>
      {params.location === "associado" ?
        <div className="user_profile">
          <Typography className="user_subtitle"variant="subtitle1">
            Bio:
          </Typography>
          <Typography className="user_bio" variant="body2">
            {user.bio ? limparHTML(user.bio) : ""}
          </Typography>
          {user.formacoes ? 
            <div>
              <Typography className="user_subtitle" variant="subtitle1">
                Formação:
              </Typography>
              <ul>
                <Typography className="user_formation" variant="body2">
                    {user.formacoes.map((formacao, index) => (<li key={index}>{formacao}</li>))}
                </Typography>
              </ul>
            </div> : ""}
            {user.experiencias ?
              <div>
                <Typography className="user_subtitle" variant="subtitle1">
                  Experiências:
                </Typography>
              <ul>
                <Typography className="user_pastrojects" variant="body2">
                    {user.experiencias.map((experiencias, index) => (<li key={index}>{experiencias}</li>))}
                </Typography>
              </ul>
            </div>
          : ""}
        </div>
      : <></>}
    </Box>
  );
}